import { combineReducers } from 'redux';
import { omit } from 'lodash';

import {
  AUTHENTICATE_USER,
  UNAUTHENTICATE_USER,
  LOGIN_WITH_TOKEN,
  FETCH_USER_EXISTS,
  FETCH_PAYMENT_SOURCES,
  FETCH_CREATE_PAYMENT_SOURCE,
  FETCH_GUEST_SIGN_UP,
  FETCH_USER_SIGNUP,
  FETCH_USER_UPDATE,
  FETCH_SET_NEW_PASSWORD,
  FETCH_UPGRADE_GUEST_USER,
  FETCH_USER,
} from '../actions/index';

import storage from '../lib/storage';

const setUser = (state, action) => {
  const { payload } = action;
  const { id } = payload;
  const user = omit(payload, ['accessToken']);
  const prevAuth = storage.getItem('auth');
  storage.setItem('auth', { ...prevAuth, ...payload });

  return {
    ...state,

    [id]: {
      ...state[id],
      ...user,
    },
  };
};

const addPaymentSource = (state, action) => {
  const { payload, payload: { id } } = action;
  const paymentSources = state[id].paymentSources || [];

  return {
    ...state,
    [id]: { ...state[id], paymentSources: [...paymentSources, ...payload.paymentSources] },
  };
};

const addPaymentSources = (state, action) => {
  const { payload, payload: { id } } = action;

  return {
    ...state,
    [id]: { ...state[id], paymentSources: [...payload.paymentSources] },
  };
};

const removeUser = (state, action) => {
  const currentUser = storage.getItem('auth');

  if (currentUser) {
    storage.removeItem('auth');
    storage.removeItem('sessionId');
    storage.removeItem('language');
    return {
      ...omit(state, currentUser.id),
    };
  }

  return state;
};

const usersById = (state = {}, action) => {
  switch (action.type) {
    case AUTHENTICATE_USER:
    case LOGIN_WITH_TOKEN:
    case FETCH_GUEST_SIGN_UP:
    case FETCH_USER_SIGNUP:
    case FETCH_USER_UPDATE:
    case FETCH_SET_NEW_PASSWORD:
    case FETCH_UPGRADE_GUEST_USER:
    case FETCH_USER:
      return setUser(state, action);

    case UNAUTHENTICATE_USER:
      return removeUser(state, action);

    case FETCH_PAYMENT_SOURCES:
      return addPaymentSources(state, action);

    case FETCH_CREATE_PAYMENT_SOURCE:
      return addPaymentSource(state, action);

    default:
      return state;
  }
};

const currentUser = (state = null, action) => {
  switch (action.type) {
    case AUTHENTICATE_USER:
    case FETCH_GUEST_SIGN_UP:
    case LOGIN_WITH_TOKEN: {
      return action.payload.id;
    }
    case UNAUTHENTICATE_USER:
      return null;
    default:
      return state;
  }
};

const userExistence = (state = null, action) => {
  switch (action.type) {
    case FETCH_USER_EXISTS: {
      return action.payload;
    }

    default:
      return state;
  }
};

export default combineReducers({
  byId: usersById,
  current: currentUser,
  editting: (state, action) => ({}),
  existence: userExistence,
});



// WEBPACK FOOTER //
// ./src/reducers/users.reducer.js